
import { defineComponent, ref, computed, onMounted, watch } from 'vue';
import { usePatientsStore } from '@/store/patients'
import { useRouter } from 'vue-router';

export default defineComponent({
  components: {
  },
  props:{
  },
  setup(props, {emit}) {
    const patientInfo = computed(() => usePatientsStore().getCurrPatient);

    watch(() => patientInfo.value, (newVal) => {
      // console.log('patientInfo >> ', patientInfo.value);
    });

    onMounted(() => {
    });

    return {
      patientInfo
    };
  },
});
